<template>
    <div class="survey-exercises-container">
        <div class="survey-exercises-container__field">
            <div class="form-container" v-for="(child, index) in model.exercises"
                 v-bind:key="index">
                <div class="form-container__row">
                    <div class="form-container__field">
                        <md-field>
                            <label>Nazwa ćwiczenia</label>
                            <md-input v-model="child.name"
                                      v-on:change="onModelChange('name')"
                                      :disabled="readonlyMode"></md-input>
                        </md-field>
                    </div>
                    <div class="form-container__field">
                        <md-field v-bind:class="{'has-error': errors.has('series_' + index) }">
                            <label>Liczba serii</label>
                            <md-input v-bind:name="'series_' + index"
                                      v-model="child.series"
                                      v-on:change="onModelChange('series_' + index)"
                                      v-bind:key="index"
                                      type="text"
                                      v-validate="'numeric|min_value:0'"
                                      :disabled="readonlyMode">
                            </md-input>
                            <span class="md-error help is-danger"
                                  v-bind:class="{'visible': errors.has('series_' + index) }">
                                Wpisz dodatnią liczbę.</span>
                        </md-field>
                    </div>
                    <div class="form-container__field">
                        <md-field v-bind:class="{'has-error': errors.has('count_' + index) }">
                            <label>Liczba powtórzeń</label>
                            <md-input v-bind:name="'count_' + index"
                                      v-model="child.count"
                                      v-on:change="onModelChange('count_' + index)"
                                      v-bind:key="index"
                                      type="text"
                                      v-validate="'numeric|min_value:0'"
                                      :disabled="readonlyMode">
                            </md-input>
                            <span class="md-error help is-danger"
                                  v-bind:class="{'visible': errors.has('count_' + index) }">
                                Wpisz dodatnią liczbę.</span>
                        </md-field>
                    </div>
                    <div class="form-container__field">
                        <md-field v-bind:class="{'has-error': errors.has('time_' + index) }">
                            <label>Czas wyk. powtórzeń (min)</label>
                            <md-input v-bind:name="'time_' + index"
                                      v-model="child.time"
                                      v-on:change="onModelChange('time_' + index)"
                                      v-bind:key="index"
                                      type="text"
                                      v-validate="'numeric|min_value:0'"
                                      :disabled="readonlyMode">
                            </md-input>
                            <span class="md-error help is-danger"
                                  v-bind:class="{'visible': errors.has('time_' + index) }">
                                Wpisz dodatnią liczbę.</span>
                        </md-field>
                    </div>
                </div>
                <div class="print">
                  <span>Uwagi do ćwiczenia</span>
                  <div>{{ child.comments }}</div>
                </div>
                <div class="form-container__textarea not-print">
                  <md-field>
                    <label>Uwagi do ćwiczenia</label>
                    <md-textarea 
                      v-model="child.comments" 
                      v-on:change="onModelChange('comments')"
                      v-on:keyup="onCommentsKeyup" 
                      :disabled="readonlyMode"
                    ></md-textarea>
                  </md-field>
                </div>
                <btn v-if="!readonlyMode && model.exercises.length > 1" class="remove-exercise-btn btn-text"
                     text="Usuń" @click="removeChild(index)"></btn>
            </div>
            <btn class="add-exercise-btn btn-text" v-if="!readonlyMode"
                 text="+ Dodaj ćwiczenie" @click="addNewChild"></btn>
        </div>
    </div>
</template>

<script>
import store from '../../store';
import {resizeTextarea, resizeAllTextarea} from '../../app-func';

export default {
  name: 'SurveyExercises',
  props: ['field'],
  data() {
    return {
      readonlyMode: store.state.visit.readonlyMode,
      model: {
        exercises: [{
          name: null,
          series: null,
          count: null,
          comments: null,
        }],
      },
    };
  },
  methods: {
    addNewChild() {
      this.model.exercises.push({
        name: null,
        series: null,
        count: null,
        comments: null,
      });
    },
    removeChild(index) {
      this.model.exercises.splice(index, 1);
      this.onModelChange();
    },
    onCommentsKeyup (event) {
      resizeTextarea(event);
    },
    onModelChange() {
      this.model.exercises.forEach((item) => {
        if (isNaN(item.series)) {
          item.series = null;
        }
        if (isNaN(item.count)) {
          item.count = null;
        }
      });
      this.$emit('modelChange', {
        newVal: JSON.stringify(this.model),
        oldVal: JSON.stringify(this.field.value),
        fieldId: this.field.id,
      });
      this.field.value = JSON.stringify(this.model);
      this.$emit('nodeChange', this.field);
      // }
    },
  },
  created() {
    if (this.model.exercises.length === 0) {
      this.addNewChild();
    }

    if (this.field.value) {
      this.model = JSON.parse(this.field.value);
    }
  },
  mounted() {
    resizeAllTextarea();
  },
};
</script>

<style src="./SurveyExercises.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/SurveyExercises/SurveyExercises.vue